// src/hooks/shared/getContractSize.js
// Возвращает КОЛ-ВО МОНЕТ В 1 КОНТРАКТЕ для фьючерсного инструмента.
// Кешируем результат, чтобы не дергать REST каждый раз.

const PROXY = "";
const cache = new Map(); // key: `${exchange}:${symbol}` -> number

/**
 * @param {"gate"|"mexc"|"bitget"|"kucoin"} exchange
 * @param {string} symbol   // тот же, что вы используете в хуках (например: "ETH_USDT", "ETHUSDT", "ETHUSDTM")
 * @returns {Promise<number>} монет/контракт (>=1e-18; если не нашли — 1)
 */
export async function getFuturesContractSize(exchange, symbol) {
  const key = `${exchange}:${symbol}`;
  if (cache.has(key)) return cache.get(key);

  let size = 1;

  try {
    if (exchange === "gate") {
      // Берём quanto_multiplier
      // GET /api/v4/futures/usdt/contracts/{contract}
      const url = `${PROXY}/https://api.gateio.ws/api/v4/futures/usdt/contracts/${encodeURIComponent(symbol)}`;
      const r = await fetch(url);
      if (r.ok) {
        const j = await r.json();
        const v = Number(j?.quanto_multiplier);
        if (Number.isFinite(v) && v > 0) size = v;
      }
    }

    else if (exchange === "mexc") {
      // GET /api/v1/contract/detail?symbol=BTC_USDT
      // data[].contractSize — кол-во монет на 1 контракт
      // Если символ не передан/не найден — возьмём первый подходящий
      const baseUrl = `https://contract.mexc.com/api/v1/contract/detail`;
      const url = symbol
        ? `${PROXY}/${baseUrl}?symbol=${encodeURIComponent(symbol)}`
        : `${PROXY}/${baseUrl}`;
      const r = await fetch(url);
      if (r.ok) {
        const j = await r.json();
        const arr = Array.isArray(j?.data) ? j.data : (j?.data ? [j.data] : []);
        let row = arr.find((x) => x?.symbol === symbol);
        if (!row && arr.length) {
          // fallback — по baseCoin/quoteCoin
          const base = symbol?.split("_")?.[0] ?? "";
          row = arr.find((x) => x?.baseCoin?.toUpperCase() === base?.toUpperCase());
        }
        const v = Number(row?.contractSize);
        if (Number.isFinite(v) && v > 0) size = v;
      }
    }

    else if (exchange === "bitget") {
      // GET /api/mix/v1/market/contracts?productType=umcbl
      // В ответе sizeMultiplier — это множитель количества (в базовой монете)
      const url = `${PROXY}/https://api.bitget.com/api/mix/v1/market/contracts?productType=umcbl`;
      const r = await fetch(url);
      if (r.ok) {
        const j = await r.json();
        const arr = Array.isArray(j?.data) ? j.data : [];
        // Возможные формы входного symbol: "ETHUSDT", "ETH_USDT"
        const norm = symbol.replace("_", "");
        const row =
          arr.find((x) => x?.symbol?.startsWith(norm)) ||
          arr.find((x) => x?.symbol?.includes(norm));
        const v = Number(row?.sizeMultiplier);
        if (Number.isFinite(v) && v > 0) size = v;
      }
    }

    else if (exchange === "kucoin") {
      // GET /api/v1/contracts/active
      // Берём multiplier для "ETHUSDTM"
      const url = `${PROXY}/https://api-futures.kucoin.com/api/v1/contracts/active`;
      const r = await fetch(url);
      if (r.ok) {
        const j = await r.json();
        const arr = Array.isArray(j?.data) ? j.data : [];
        const row = arr.find((x) => x?.symbol === symbol);
        const v = Number(row?.multiplier);
        if (Number.isFinite(v) && v > 0) size = v;
      }
    }
  } catch {
    // тихо игнорируем — вернём size=1
  }

  cache.set(key, size);
  return size;
}
